import styled from 'styled-components';

type TableHeaderProps = {
	autoHeight?: boolean;
	bordered?: boolean;
}

export const TableHeader = styled.div<TableHeaderProps>`
	display: flex;
	height: ${props => props.autoHeight ? 'auto' : '24px'};
	border-bottom: ${props => props.bordered && '1px solid #bdbdbd'};
`;
